import { clearTimeouts, engine as anime } from "../index";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id, format } = props;

  const timeline = anime.timeline();
  $(`#${id} .headline`).css("opacity", 0);
  $(`#${id} .player-image`).css("opacity", 0);

  const params = {};
  params.headlineTop = 370;
  params.headlineScale = 1.3;

  if (format === "1200x1500") {
    params.headlineTop = 550;
    params.headlineScale = 1.1;
  }

  anime
    .timeline({
      targets: `#${id} .headline`,
      easing: "easeInOutQuint",
      delay: 100,
    })
    .add({
      scale: [0, params.headlineScale],
      duration: 900,
      opacity: [1, 1],
    })
    .add({
      scale: [params.headlineScale, 1.0],
      top: [params.headlineTop, $(`#${id} .headline`).css("top")],
      duration: 600,
      delay: 100,
      opacity: [1, 1],
    });

  anime({
    targets: $(`#${id} .player-image`).toArray(),
    easing: "easeOutQuint",
    duration: 700,
    // rotateZ: [22, 22],
    opacity: [1, 1],
    translateY: [1500, 0],
    delay: anime.stagger(800, { start: 1500 }),
  });

  anime({
    targets: [`#${id} .stat-value`],
    easing: "easeOutQuint",
    duration: 300,
    // rotateZ: [22, 22],S
    opacity: [1, 1],
    scale: [0, 1],
    delay: anime.stagger(800, { start: 2000 }),
  });

  anime({
    targets: [`#${id} .player-name-container`],
    keyframes: [
      { clipPath: "inset(100% 0 0 0)", duration: 0 },
      { clipPath: "inset(0% 0 0 0)", duration: 300 },
    ],
    easing: "easeInOutQuart",
    opacity: [1, 1],
    delay: anime.stagger(800, { start: 1600 }), // 200ms delay between each elemen
  });

  anime({
    targets: [`#${id} .stat-type`],
    easing: "easeOutQuint",
    duration: 400,
    opacity: [1, 1],
    scale: [0, 1],
    delay: 4000,
  });

  const timeout1 = setTimeout(() => {
    anime({
      targets: $(`#${id} .player-0 .player-image`).get(),
      easing: "linear",
      duration: 15000,
      translateX: 0,
      scale: [1, 1.2],
    });

    anime({
      targets: $(`#${id} .player-1 .player-image`).get(),
      easing: "linear",
      duration: 15000,
      translateY: 100,
    });
    anime({
      targets: $(`#${id} .player-2 .player-image`).get(),
      easing: "linear",
      duration: 15000,
      translateY: 100,
    });
  }, 4000);

  timeouts.push(timeout1);

  return {
    timeline: timeline,
    timeouts: timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
